import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Event,
  NavigationStart,
} from '@angular/router';

import { RoutePartsService } from './shared/services/route-parts.service';
import { ThemeService } from './shared/services/theme.service';

import { filter } from 'rxjs/operators';
import { AgentProfileService } from './shared/services/agent-profile.service';

import { Agent } from './shared/models/agent.model';
import { LoginService } from './shared/services/login.service';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { LayoutService } from './shared/services/layout.service';
import { JwtDecoder } from './shared/services/auth/jwt-decoder.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit {
  appTitle = 'Mashvisor';
  pageTitle = '';
  public agentInfo: Agent;
  agentInfoSub: Subscription;
  agentInfoPlanSub: Subscription;
  agentInfoAgencySub: Subscription;
  agentPermissions;
  permissionsSub: Subscription;

  constructor(
    private layout: LayoutService,
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private themeService: ThemeService,
    private renderer: Renderer2,
    private agentInfoService: AgentProfileService,
    private cookie: CookieService,
    private loginService: LoginService,
    private userInfo: JwtDecoder,
  ) {
    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }

      if (event instanceof NavigationEnd) {
        try {
          let currentView = this.router.url.split('/')[1];
          currentView = currentView.toUpperCase();
          if (this.userInfo) {
            (<any>window)._mva.push({
              USER_ID:
                ((<any>window).mvGDPR && (<any>window).mvGDPR.isBlocked) ||
                this.userInfo.getUserInformation().user.id,
              PLAN: this.userInfo.getUserInformation().user.subscription_plan,
              ACTION: currentView ? `VIEW_${currentView}` : `VIEW_MASHBOARD`,
              ENTITY: 'MASHBOARD',
              URL: this.router.url,
            });
          }
        } catch (error) {}
      }
    });
  }

  ngOnInit() {
    this.changePageTitle();
    if (this.cookie.get('squanchy')) {
      if (this.loginService.checkToken()) {
        this.agentInfoSub = this.agentInfoService.getAgent().subscribe(data => {
          (<any>window).MVASDK.push({
            user_id: data.id || '0000',
            plan: this.userInfo.getUserInformation().user.subscription_plan,
          });
          (<any>window).Intercom('boot', {
            app_id: 'o8bzwj24',
            user_id: data.id,
            name: data.user_profile.first_name,
            email: data.email,
          });
          this.agentInfo = new Agent(data);
          this.agentInfoService.addAgentData(this.agentInfo);
          (<any>window).__insp &&
            (<any>window).__insp.push(['identify', data.id]);
          (<any>window).__insp &&
            (<any>window).__insp.push(['tagSession', { userId: data.id }]);
          (<any>window).dataLayer.push({
            event: 'pageview',
            customUserID: data.id,
            userId: data.id,
          });
        });
        this.permissionsSub = this.agentInfoService
          .getAgentPermissions()
          .subscribe(data => {
            this.agentPermissions = data;
            this.agentInfoService.addAgentPermissions(this.agentPermissions);
          });
        this.agentInfoPlanSub = this.agentInfoService
          .getAgentSubscription()
          .subscribe(data => {
            this.agentInfoService.addAgentSubscription(data);
            // this.agentSubscriptionData = data.results[0].plan;
          });
        this.agentInfoAgencySub = this.agentInfoService
          .getAgentAgency()
          .subscribe(data => {
            this.agentInfoService.addAgentAgencyData(data);
          });
      }
    }
    this.changeToTopBar();
    this.initializeIframeMessages();
  }

  initializeIframeMessages() {
    window.addEventListener('message', event => {
      const data = event.data;
      if (data.sender === 'search-app') {
        const slug = data.message.slug;
        this.router.navigate([`/${slug}`]);
      }
    });
  }

  changeToTopBar() {
    window.addEventListener(
      'topBar',
      e => {
        var layoutNew = {
          navigationPos: 'top',
          sidebarStyle: 'full',
          dir: 'ltr',
          useBreadcrumb: true,
          topbarFixed: false,
          breadcrumb: 'title',
        };
        this.layout.setAppLayout(layoutNew);
        this.router
          .navigateByUrl('/property-finder', { skipLocationChange: true })
          .then(() => this.router.navigate(['']));
      },
      false,
    );
  }

  ngOnDestroy() {
    if (this.agentInfoSub) this.agentInfoSub.unsubscribe();
    if (this.agentInfoPlanSub) this.agentInfoPlanSub.unsubscribe();
    if (this.agentInfoAgencySub) this.agentInfoAgencySub.unsubscribe();
  }

  ngAfterViewInit() {
    this.themeService.applyMatTheme(this.renderer);
  }
  changePageTitle() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(routeChange => {
        var routeParts = this.routePartsService.generateRouteParts(
          this.activeRoute.snapshot,
        );
        if (!routeParts.length) return this.title.setTitle(this.appTitle);
        // Extract title from parts;
        this.pageTitle = routeParts
          .reverse()
          .map(part => part.title)
          .reduce((partA, partI) => {
            return `${partA} > ${partI}`;
          });
        this.pageTitle += ` | ${this.appTitle}`;
        this.title.setTitle(this.pageTitle);
      });
  }
}
